import { useCallback } from "react";

type UseListManagementOptions<T> = {
  createBlank: () => T;
  minItems?: number;
};

export function useListManagement<T>(
  initialValue: T[],
  options: UseListManagementOptions<T>
) {
  const { createBlank } = options;

  const updateItem = useCallback(
    (index: number, next: T) => {
      const copy = [...initialValue];
      copy[index] = next;
      return copy;
    },
    [initialValue]
  );

  const addItem = useCallback(() => {
    return [...initialValue, createBlank()];
  }, [initialValue, createBlank]);

  const removeItem = useCallback(
    (index: number) => {
      const filtered = initialValue.filter((_, i) => i !== index);
      return filtered.length > 0 ? filtered : [createBlank()];
    },
    [initialValue, createBlank]
  );

  return { updateItem, addItem, removeItem };
}
